<template>
  <div>
    <!-- gelişmiş filtre start  -->
    <div class="text-right mb-1 mt-0 ">
      <a href="javascript:;" @click="toggleFilter">
        <span v-if="filterEnabled" class="text-primary">
          <i class="bx bxs-filter-alt"></i>
          {{ $t("common.filters-hide") }}
        </span>
        <span v-else class="text-primary">
          <i class="bx bxs-filter-alt"></i>
          {{ $t("common.advanced-filtering") }}
        </span>
      </a>
    </div>
    <div v-if="filterEnabled">
      <br />
      <div v-if="!hideCategoryFilter">
        <filter-select
          id="categoryFilter"
          ref="categoryFilter"
          :placeholder="$t('common.category')"
          :multiple="false"
          @filter="onCategorySearch"
          @changed="onCategorySelect"
          class="category-filter"
        />
      </div>
    </div>

    <!-- gelişmiş Filtre - end -->
    <hr />
    <div class="h-100  mb-4 d-flex align-items-center">
      <div v-if="languageFilterEnabled">
        <LanguageFilter :request="libraryRequest" @changed="languageFilterChanged" />
      </div>
      <div class="flex-grow-1 d-flex align-items-center">
        <input v-model="libraryRequest.query.name.value" type="text" class="form-control bg-white text-dark " :placeholder="$t('common.search')" />
      </div>
    </div>

    <content-loading v-if="isLibraryLoading" />
    <empty v-if="!isLibraryLoading && (!libraryPagination || libraryPagination.docs.length == 0)" width="100px" />
    <div v-if="libraryPagination">
      <div v-if="!multiSelectEnabled">
        <b-card v-for="item in libraryPagination.docs" no-body class="custom-accordion shadow-none mb-1" :key="item._id">
          <b-card-body class="p-2 hider">
            <i v-if="!hideAddFromLibrary" class="mdi mdi-plus float-right text-success hand hidden" v-b-tooltip.hover :title="fromLibraryTitle" @click="addFromLibrary(item)"></i>
            <i v-if="!hideSaveAs" class="mdi mdi-pencil float-right text-primary hand mr-3 hidden" v-b-tooltip.hover :title="saveAsButtonText(item)" @click="copyToForm(item)"></i>
            <h6 class="mb-0">
              <i v-if="item.scope.value == 'workspace'" v-b-tooltip.hover :title="$t('workspace.yours')" class="text-muted mdi mdi-hexagon-multiple-outline"></i>
              <i v-else class="text-muted mdi mdi-database" v-b-tooltip.hover :title="$t('library.belonging-to-the-system')"></i>
              {{ item.name | translate }}
            </h6>
          </b-card-body>
        </b-card>
      </div>
      <div v-else>
        <div class="d-flex flex-row " v-if="libraryPagination && libraryPagination.docs.length > 0">
          <div class="mr-3">
            <!-- <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
              <template #button-content>
                <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
              </template>

              <b-dropdown-item href="#" @click="addSelectedItems(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                <i class="mdi mdi-plus text-success" v-b-tooltip.hover :title="fromLibraryTitle"></i> {{ fromLibraryTitle }} ({{ selectedItems.length }})
              </b-dropdown-item>
            </b-dropdown> -->

            <button @click="selectAllItems" class="btn btn-sm btn-secondary">
              <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
            </button>
          </div>
          <div>
            <button class="btn btn-sm btn-success" variant="success" @click="addSelectedItems(selectedItems)" v-if="isAtLeastOneItemSelected" :disabled="!isAtLeastOneItemSelected">
              <i class="mdi mdi-plus text-success" v-b-tooltip.hover :title="fromLibraryTitle"></i> {{ fromLibraryTitle }} ({{ selectedItems.length }})
            </button>
          </div>
        </div>

        <table class="table project-list-table compact">
          <tbody>
            <tr class="hider" v-for="item in libraryPagination.docs" :key="item._id">
              <td>
                <div class="text-center">
                  <b-form-checkbox v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                </div>
              </td>
              <td>{{ item.name | translate }}</td>
              <td><i class="mdi mdi-plus float-right text-success hand hidden mt-1 mr-2" v-b-tooltip.hover :title="fromLibraryTitle" @click="addFromLibrary(item)"></i></td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-modal id="modal-multiple-add-operation" centered :title="$t('common.multiple-add-operation')" hide-footer>
        <div v-if="addOperationResult.success.length > 0">
          <h5 class="text-success">{{ $t("common.add-items") }}</h5>
          <ul>
            <li v-for="item in addOperationResult.success" :key="item._id">
              {{ item.name | translate }}
            </li>
          </ul>
        </div>

        <div v-if="addOperationResult.failed.length > 0">
          <h5 class="text-danger mt-4">{{ $t("common.add-failed") }}</h5>
          <ul>
            <li v-for="item in addOperationResult.failed" :key="item._id">
              <b> {{ item.name | translate }}</b>
              {{ item.error }}
            </li>
          </ul>
        </div>
      </b-modal>

      <!-- Begin: Pagination -->

      <div class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="libraryRequest.options.page" :total-rows="libraryPagination.totalDocs" :per-page="libraryPagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
    </div>
  </div>
</template>

<script>
import LanguageFilter from "@c/language-filter";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  components: { VueSlickCarousel, LanguageFilter },
  props: [
    "rightPanelId",
    "organizationScopedState",
    "libraryScopedState",
    "libraryScopedStateCategory",
    "hideCategoryFilter",
    "hideSaveAs",
    "hideAddFromLibrary",
    "query",
    "addFromLibraryTitle",
    "navigateInsteadAddFromLibrary",
    "languageFilterEnabled",
    "multiSelectEnabled",
    "shouldAdaptSaveAsButtonTextToScopeAndCurrentAccount", //  entity.createdBy=>currentAccount ve ws scope=> düzele , system scope=> save as
  ],
  data() {
    return {
      filterEnabled: false,
      settings: {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 2,
        autoplay: false,
        speed: 500,
        autoplaySpeed: 3000,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        swipeToSlide: true,
        dots: false,
        variableWidth: true,
        adaptiveHeight: true,
      },
      selectedItems: [],
      libraryRequest: {
        options: { page: 1, limit: 20, sort: { name: "asc" } },
        query: { name: { value: "" }, category: undefined, "scope.value": undefined },
      },
      selectedWsp: undefined,
      selectedSys: undefined,
      selectedAll: true,
    };
  },
  watch: {
    query: {
      deep: true,

      handler(v) {
        this.fetchLibraryItems();
      },
    },
    libraryRequest: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.fetchLibraryItems());
      },
    },
  },
  computed: {
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
    addOperationResult() {
      return this.$store.getters[`${this.organizationScopedState}/addOperationResult`];
    },

    libraryPagination() {
      return this.$store.getters[`${this.libraryScopedState}/pagination`];
    },
    isLibraryLoading() {
      return this.$store.getters[`${this.libraryScopedState}/isLoading`];
    },
    fromLibraryTitle() {
      return this.addFromLibraryTitle ? this.addFromLibraryTitle : this.$t("common.add-to-organization");
    },
  },
  mounted() {},
  methods: {
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.libraryPagination?.docs?.slice() || [];
      }
    },
    saveAsButtonText(item) {
      if (this.shouldAdaptSaveAsButtonTextToScopeAndCurrentAccount && item?.scope?.createdBy?._id == this.currentAccount?._id && item?.scope?.value == "workspace") {
        return this.$t("common.update");
      }
      return this.$t("common.save-as");
    },
    async addSelectedItems(items) {
      try {
        if (this.navigateInsteadAddFromLibrary) {
          return this.navigateInsteadAddFromLibrary(libraryItem);
        }
        const payload = items.map((i) => ({ libraryItem: i, product: i.products }));

        await this.$store.dispatch(`${this.organizationScopedState}/multipleAddFromLibrary`, payload);
        this.form = {};
        this.selectedItems = [];
        this.$root.$emit("bv::show::modal", "modal-multiple-add-operation");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    languageFilterChanged(e) {
      this.libraryRequest = e;
    },
    selectWorkspace() {
      this.selectedAll = false;
      this.selectedWsp = !this.selectedWsp;
      this.selectedSys = false;

      if (!this.selectedWsp) {
      } else {
        this.libraryRequest.query = {
          ...this.libraryRequest.query,
          "scope.value": { value: "workspace", isObject: true },
        };
      }
    },
    selectSystem() {
      this.selectedAll = false;
      this.selectedWsp = false;
      this.selectedSys = !this.selectedSys;

      if (!this.selectedSys) {
      } else {
        this.libraryRequest.query = {
          ...this.libraryRequest.query,
          "scope.value": { value: "system", isObject: true },
        };
      }
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
      this.libraryRequest.query["category"] = undefined;
    },

    onCategorySelect(item) {
      if (item) {
        this.libraryRequest.query = {
          ...this.libraryRequest.query,
          category: { value: item._id, isObject: true },
        };
      } else {
        this.libraryRequest.query["category"] = undefined;
      }
    },
    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`${this.libraryScopedStateCategory}/paginate`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    copyToForm(item) {
      this.$emit("interceptForSetParent", item);
      this.$store.commit(`${this.organizationScopedState}/copingEntity`, { ...item, libraryItem: item, _id: undefined });
    },

    async addFromLibrary(libraryItem) {
      try {
        if (this.navigateInsteadAddFromLibrary) {
          return this.navigateInsteadAddFromLibrary(libraryItem);
        }
        const payload = {
          libraryItem,
          product: libraryItem.products,
        };
        this.$emit("interceptForSetParent", payload);
        await this.$store.dispatch(`${this.organizationScopedState}/addFromLibrary`, payload);
        this.form = {};
        this.$toast.success("'" + this.$options.filters.translate(libraryItem.name) + "' Eklendi");
        //? this.$root.$emit("bv::toggle::collapse", this.rightPanelId);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    fetchLibraryItems() {
      const req = { ...this.libraryRequest };
      if (this.query) {
        req.query = {
          ...req.query,
          ...this.query,
        };
      }
      this.$store.dispatch(`${this.libraryScopedState}/paginate`, req);
    },
  },
};
</script>

<style>
.slick-prev:before,
.slick-next:before {
  font-family: "slick";
  font-size: 20px;
  line-height: 1;
  opacity: 0.75;
  color: #0c116faa !important;
}

.category-filter {
  border: 1px solid #00000000;
  border-radius: 28px;
  padding: 0px;
  max-width: 500px;
  /* background-color: #0ecce6;
  color: #0ecce6; */
}
</style>
<style scoped>
.badge {
  font-weight: bold !important ;
}
</style>
